import {CycleCountRemainingItem} from "./CycleCountRemainingItem";
import {CycleCountItemResponse} from "./CycleCountItemResponse";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {PAGE_SIZE} from '../app/app.constants';

export class CycleCountRemainingGroup {

  Group: string;

  GroupQty: number;
  GroupQtyObservable: Observable<number>;
  GroupQtyObserver: Observer<number>;

  itemList: Array<CycleCountRemainingItem>;
  itemListObservable: Observable<Array<CycleCountRemainingItem>>;
  itemListObserver: Observer<Array<CycleCountRemainingItem>>;

  expanded: boolean = false;
  page: number = 0;
  pageMax: number = 0;

  constructor(Group: string, GroupQty: number, itemList: Array<CycleCountRemainingItem>, expanded: boolean) {
    this.Group = Group;
    this.GroupQty = GroupQty;
    this.itemList = itemList;
    this.expanded = expanded;

    this.pageMax = this.itemList ? Math.trunc(this.itemList.length / PAGE_SIZE) : 0;
  }

  fromCycleCountItemResponse(itemResponse: CycleCountItemResponse): CycleCountRemainingGroup {
    this.Group = itemResponse.Group;
    this.GroupQty = Number(itemResponse.GroupQty);
    this.itemList = []; // this function is only called when a new Group has to be created
    this.itemList.push(new CycleCountRemainingItem().fromCycleCountItemResponse(itemResponse));
    return this.initObservables();
  }

  initObservables(): CycleCountRemainingGroup {
    this.itemListObservable = new Observable(observer => {
      this.itemListObserver = observer;
      this.itemListObserver.next(this.itemList);
    });

    this.GroupQtyObservable = new Observable(observer => {
      this.GroupQtyObserver = observer;
      this.GroupQtyObserver.next(this.GroupQty);
    });

    return this;
  }

  clone() {
    //Create a deep clone of the list

    // let clonedItemList: Array<CycleCountRemainingItem> = [];
    // for(let remainingItem of this.itemList){
    //   clonedItemList.push(remainingItem.clone());
    // }
    return new CycleCountRemainingGroup(this.Group, this.GroupQty, this.itemList, this.expanded);
  }
}



// WEBPACK FOOTER //
// ./src/models/CycleCountRemainingGroup.ts